import { render, staticRenderFns } from "./PdvSuccess.vue?vue&type=template&id=06d3c79b"
import script from "./PdvSuccess.vue?vue&type=script&lang=js"
export * from "./PdvSuccess.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports